import React, { useRef, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useUpdatefaq } from "../../../../../api/inquiries/faq/use-faq";
import { useFAQCategory } from "../../../../../api/inquiries/faq/use-faq-category";
import { useFAQById } from "../../../../../api/inquiries/faq/use-faq-detail";
import TitlePage from "../../../../../components/section/TitlePage/Titlepage";
import Button from "../../../../../components/ui/Button/Button";
import { Dropdown } from "../../../../../components/ui/Dropdown/Dropdown";
import Modal from "../../../../../components/ui/Modal/Modal";
import FieldBox from "../../../../../utils/Form/ui/FieldBox";
import Editor from "../../../../../components/Editor";

const FAQEditPage = () => {
  const quillRef = useRef(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const { data } = useFAQById(id);
  const faqData = data?.data;

  const { data: faqCategory } = useFAQCategory();
  const faqCategoryData = faqCategory?.data;
  const options = faqCategoryData?.map((res) => {
    return {
      id: res?.id,
      name: res?.name,
    };
  });
  const [title, setTitle] = React.useState(faqData?.title);
  const [category, setCategory] = React.useState(faqData?.faqCategory?.id);

  const { mutate: updateFAQ } = useUpdatefaq();
  const [isContentsEmpty, setIsContentsEmpty] = useState(false);

  const formEmpty = useMemo(() => {
    return title === "" || category === "" || isContentsEmpty;
  }, [title, category, isContentsEmpty]);

  const onTextChange = (content) => {
    setIsContentsEmpty(quillRef?.current?.getLength() === 1);
  };

  const onChangeTitle = (e) => {
    setTitle(e.target.value);
  };
  const handleSubmit = async () => {
    const payload = {
      id: id,
      title: title,
      contents: JSON.stringify(quillRef?.current?.getContents()),
      faqCategoryId: category,
    };
    await updateFAQ(payload);
  };

  const handleBack = () => {
    navigate("/bulletin-board");
  };

  return (
    <>
      <div>
        <TitlePage title="FAQ > FAQ 상세 > FAQ 수정" />
        <div className="mt-4">
          <form>
            <FieldBox label="분류">
              <Dropdown
                display="inline"
                width="w-72"
                options={options}
                placeholder="분류 유형 선택"
                positionDropdown={`top-8`}
                onClickItem={(id) => setCategory(id)}
                defaultValue={faqData?.faqCategory?.id}
              />
            </FieldBox>

            <FieldBox label="제목">
              <input
                className="rounded-[4px] w-full text-[12px] p-2 focus:outline-none"
                placeholder="제목을 입력해주세요."
                name="title"
                value={title}
                onChange={onChangeTitle}
              />
            </FieldBox>
            <FieldBox alignItems="pt-6" isLast label="내용" padding="p-0">
              <Editor
                ref={quillRef}
                defaultValue={JSON.parse(faqData?.contents)}
                onTextChange={onTextChange}
              />
            </FieldBox>
            <div className="flex justify-end mt-4">
              <Modal
                description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다."
                onSubmit={handleBack}
              >
                <Button text="입력취소" />
              </Modal>
              <Modal
                description={
                  <span>
                    해당 FAQ를 수정하시겠습니까? 수정 후 언제든지 다시 변경 또는
                    삭제할 수 있습니다.
                    <br />
                    <br />
                    ■ 안내사항
                    <br />
                    작성하신 FAQ는 병원 웹과 앱에 노출됩니다.
                    <br />
                    FAQ 내용이 변경되는 경우, [수정]을 통해 언제든 업데이트하실
                    수 있습니다.
                  </span>
                }
                onSubmit={handleSubmit}
                submitText="FAQ 수정"
              >
                <Button
                  onClick={(e) => e.preventDefault()}
                  type="submit"
                  primary
                  text="등록완료"
                  isDisabled={formEmpty}
                />
              </Modal>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default FAQEditPage;
